import { ChallengeLevelResponse } from "@edp-models/challenge-level.model";
import { ChallengeAcceptance, ChallengeSubscription, ContentSubscription } from "@edp-models/challenge.model";
import { CollectiveChallenge } from "@edp-models/collective-challenge.model";
import { Experiences, OtherExperience } from "@edp-models/experiences.model";
import { Action } from "@ngrx/store";

export enum EChallengesActions {
    LoadChallengesLevels = "[Challenges] Loading challenges levels",
    SaveChallengesLevels = "[Challenges] Saving challenges levels",
    LoadEvent = "[Challenges] Loading event",
    SaveCollectiveChallenge = "[Challenges] Saving Collective Challenge",
    SaveExperiences = "[Challenges] Saving Experiences",
    LoadOtherEvents = "[Challenges] Loading other events",
    SaveOtherEvents = "[Challenges] Saving other events",
    IndividualChallengeSubscription = "[Challenges] Individual challenge subscription",
    SaveChallengeAcceptance = "[Challengesn] Saving individual challenge acceptance",
    CollectiveChallengeSubscription = "[Challenges] Collective challenge subscription",
    CollectiveChallengeUnSubscription = "[Challenges] Collective challenge unsubscription",
    LoadChallenges = "[Challenges] Loading challenges",
    SaveActiveChallenges = "[Challenges] Saving active challenges",
    SaveInactiveChallenges = "[Challenges] Saving inactive challenges",
    ContentChallengeSubscription = "[Challenges] Content challenge subscription",
    ConsentChallengeSubscription = "[Challenges] Consent challenge subscription",
}

export class LoadChallengesLevels implements Action {
    public readonly type = EChallengesActions.LoadChallengesLevels;
}

export class SaveChallengesLevels implements Action {
    public readonly type = EChallengesActions.SaveChallengesLevels;
    constructor(public payload: ChallengeLevelResponse) {}
}

export class LoadEvent implements Action {
    public readonly type = EChallengesActions.LoadEvent;
    constructor(public eventType?: string, public challengeId?: string, public eventCode?: string) {}
}

export class SaveCollectiveChallenge implements Action {
    public readonly type = EChallengesActions.SaveCollectiveChallenge;
    constructor(public payload: CollectiveChallenge) {}
}

export class SaveExperiences implements Action {
    public readonly type = EChallengesActions.SaveExperiences;
    constructor(public payload: Experiences) {}
}

export class LoadOtherEvents implements Action {
    public readonly type = EChallengesActions.LoadOtherEvents;
    constructor(public eventCode?: string, public eventType?: string, public limit?: number) {}
}

export class SaveOtherEvents implements Action {
    public readonly type = EChallengesActions.SaveOtherEvents;
    constructor(public payload: OtherExperience[]) {}
}

export class IndividualChallengeSubscription implements Action {
    public readonly type = EChallengesActions.IndividualChallengeSubscription;
    constructor(public payload: ChallengeSubscription) {}
}

export class SaveChallengeAcceptance implements Action {
    public readonly type = EChallengesActions.SaveChallengeAcceptance;
    constructor(public payload: ChallengeAcceptance) {}
}

export class CollectiveChallengeSubscription implements Action {
    public readonly type = EChallengesActions.CollectiveChallengeSubscription;
    constructor(public payload: ChallengeSubscription) {}
}

export class CollectiveChallengeUnSubscription implements Action {
    public readonly type = EChallengesActions.CollectiveChallengeUnSubscription;
    constructor(public payload: ChallengeSubscription) {}
}

export class LoadChallenges implements Action {
    public readonly type = EChallengesActions.LoadChallenges;
    constructor(public eventCode?: string, public eventType?: string, public limit?: number, public state?: string) {}
}
export class SaveActiveChallenges implements Action {
    public readonly type = EChallengesActions.SaveActiveChallenges;
    constructor(public payload: CollectiveChallenge[]) {}
}
export class SaveInactiveChallenges implements Action {
    public readonly type = EChallengesActions.SaveInactiveChallenges;
    constructor(public payload: CollectiveChallenge[]) {}
}

export class ContentChallengeSubscription implements Action {
    public readonly type = EChallengesActions.ContentChallengeSubscription;
    constructor(public payload: ContentSubscription) {}
}

export type ChallengesActions =
    | LoadChallengesLevels
    | SaveChallengesLevels
    | LoadEvent
    | SaveCollectiveChallenge
    | SaveExperiences
    | LoadOtherEvents
    | SaveOtherEvents
    | IndividualChallengeSubscription
    | SaveChallengeAcceptance
    | CollectiveChallengeSubscription
    | CollectiveChallengeUnSubscription
    | LoadChallenges
    | SaveActiveChallenges
    | SaveInactiveChallenges
    | ContentChallengeSubscription;
